import { useEffect, useState } from "react";
import PopupAHSF from "../../../Components/PopupAHSF";
import TableAHSF from "../../../Components/TableAHSF";

import BudgetDirectCostsAddEdit from "./BudgetDirectCostsAddEdit";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { DeleteDirectCosts } from "../../../Redux/Reducers/BudgetInformation/DirectCosts";
import { setRefreshTable } from "../../../Redux/Reducers/VariousVariables";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

const BudgetDirectCosts = () => {
  const AppGuid = useParams()
  const [bI_DirectCostsGuid, setBI_DirectCostsGuid] = useState("");
  const [PopupComponentViewStatus, setPopupComponentViewStatus] =
    useState(false);
  const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  const deleteDirectCostsLoding = useSelector(
    (state) => state.directCosts.lodingdeleteDirectCosts
  );
  const deleteDirectCosts = useSelector(
    (state) => state.directCosts.deleteDirectCosts
  );

  const UpdateDirectCosts = useSelector(
    (state) => state.directCosts.UpdateDirectCosts
  );
  const lodingUpdateDirectCosts = useSelector(
    (state) => state.directCosts.lodingUpdateDirectCosts
  );

  const addDirectCosts = useSelector(
    (state) => state.directCosts.addDirectCosts
  );
  const lodingDirectCosts = useSelector(
    (state) => state.directCosts.lodingDirectCosts
  );

  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  //popup props for show popup
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <BudgetDirectCostsAddEdit
        monthDataApi={false}
        ViewData={false}
        Action={"add"}
      />
    ),
    maxWidth: "1200px",
    maxHeight: "600px",
    title: "التكاليف المباشرة",
  };
  const RequestAccessor = [
    {
      KeyName: "objectiveName",
      ShowStatus: true,
      NmaeColumn: "الهدف",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "activity",
      ShowStatus: true,
      NmaeColumn: "النشاط",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemName",
      ShowStatus: true,
      NmaeColumn: "البند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "numberOfUnits",
      ShowStatus: true,
      NmaeColumn: "عدد الوحدات	",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "unitPrice",
      ShowStatus: true,
      NmaeColumn: "سعر الوحدة	",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "frequency",
      ShowStatus: true,
      NmaeColumn: "التكرار",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "beneficiaryContribution",
      ShowStatus: true,
      NmaeColumn: "مساهمة المستفيد",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "shomanContribution",
      ShowStatus: true,
      NmaeColumn: "مساهمة شومان",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
  ];
  //table buttons actions edit,view and delete
  const OtherMainBtns = [
    {
      Click: async (e) => {
        //console.log(e, "sldsdsd");
        setBI_DirectCostsGuid(e.target.value);
        closePopupEditComponent();
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "عرض",
      ShowStatus: !shouldDisableFields,
    },
    {
      Click: async (e) => {
        setBI_DirectCostsGuid(e.target.value);
        closePopupViewComponent();
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: shouldDisableFields,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then((res) => {
          if (res.isConfirmed == true) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            //delete row from table by id after conferm
            dispatch(DeleteDirectCosts({ bI_DirectCostsGuid: e.target.value }));
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !shouldDisableFields,
    },
  ];
  const RequestsColumns = [];
  const closePopupViewComponent = () => {
    if (PopupComponentViewStatus) {
      setPopupComponentViewStatus(false);
    } else {
      setPopupComponentViewStatus(true);
    }
  };

  const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };
//refrsh  table on change
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [
    deleteDirectCosts,
    deleteDirectCostsLoding,
    lodingUpdateDirectCosts,
    UpdateDirectCosts,
    lodingDirectCosts,
    addDirectCosts,
  ]);
//render html after get data
  return (state.ApplicationInformation && state.ActiveRound)||decryptToken(AppGuid.AppGuid) ? (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"bI_DirectCostsGuid"}
        valueButtonAction={"bI_DirectCostsGuid"}
        URL={`api/DirectCosts/GetDirectCostsListByAppGuid`}
        UrlBody={{
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          )||decryptToken(AppGuid.AppGuid) ,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"موازنة التكاليف المباشرة"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={true}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "beneficiaryContribution", nameColimn: " مساهمة المستفيد " },
          { keyName: "shomanContribution", nameColimn: " مساهمة شومان " },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
      
        // popUpBody2={[<ShowApplication addFun={true} />]}
        // popUpId2={"ShowApplicationpopUp"}
        // popUpBody2={[
        //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
        // ]}
        // handleCloseModal={handleCloseModal}
        // showModal={showPopUp}
      />
      <PopupAHSF
        title={"التكاليف المباشرة"}
        componentBody={
          <BudgetDirectCostsAddEdit
            monthDataApi={true}
            ViewData={true}
            disabledData={false}
            Action={"edit"}
            bI_DirectCostsGuid={bI_DirectCostsGuid}
          />
        }
        maxWidth="1200px"
        maxHeight="600px"
        isPopupOpenStatus={PopupComponentEditStatus}
        isPopupOpenFunction={closePopupEditComponent}
      />
      <PopupAHSF
        title={"التكاليف المباشرة"}
        componentBody={
          <BudgetDirectCostsAddEdit
            monthDataApi={true}
            ViewData={true}
            disabledData={true}
            Action={"view"}
            bI_DirectCostsGuid={bI_DirectCostsGuid}
          />
        }
        maxWidth="1200px"
        maxHeight="600px"
        isPopupOpenStatus={PopupComponentViewStatus}
        isPopupOpenFunction={closePopupViewComponent}
      />
    </>
  ) : (
    ""
  );
};

export default BudgetDirectCosts;
